import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapper: BoxProps = {};

export const TableText = ({ textVariation }: any): CSSObject => ({
  color: textVariation === 'positive' ? 'green.500' : 'white',
});
